import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SunlightRatesService from "./SunlightRatesService";

export const GetAllSunlightRates = createAsyncThunk(
    "sunlight_rate/index", async (_, thunkAPI) => {
        let {rejectWithValue, getState} = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token
            return await SunlightRatesService.GetAllSunlightRates(token);
        } catch (error)
        {
            let message = error.message
            return rejectWithValue(message)
        }
    }
)

export const CreateNewSunlightRate = createAsyncThunk(
    "sunlight_rate/create", async (data, thunkAPI) => {
        let {rejectWithValue, getState} = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token
            return await SunlightRatesService.CreateNewSunlightRate(data ,token);
        } catch (error)
        {
            return rejectWithValue(error?.response?.data?.errors);
        }
    }
)

const SunlightRates = createSlice({
    name:"sunlight_rates",
    initialState: {
        sunlights: [],
        sunlight: [],
        isSuccess: false,
        isError: false,
        isLoading: false,
        errors: [],
        message: [],
    },
    reducers: {
        sunlightRatesReset: (state) => {
            state.isSuccess =  false;
            state.isError =  false;
            state.isLoading =  false;
            state.errors =  [];
            state.message =  [];
        }
    },
    extraReducers: {
        // Get All Sun Light Rates
        [GetAllSunlightRates.pending]: state => {
            state.isLoading = true;
        },
        [GetAllSunlightRates.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true; 
            state.sunlights = action.payload;
        },
        [GetAllSunlightRates.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload 
        },

        // Create New Sun Light Rates
        [CreateNewSunlightRate.pending]: state => {
            state.isLoading = true;
        },
        [CreateNewSunlightRate.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true; 
            state.sunlights = action.payload;
        },
        [CreateNewSunlightRate.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload 
        }
    }
})

export const {sunlightRatesReset} = SunlightRates.actions
export default SunlightRates.reducer